import { defineEvent } from '../types/event';
export var BUCKET_ASSIGN = defineEvent({
    enhance: function (input, _a) {
        var adapters = _a.adapters;
        var result = {};
        var optimizelyUserContext = adapters.Optimizely;
        var configuration = optimizelyUserContext === null || optimizelyUserContext === void 0 ? void 0 : optimizelyUserContext.getOptimizely().getProjectConfig();
        if (configuration) {
            var flagRules = configuration.flagRulesMap[input.featureName];
            var validRule = flagRules === null || flagRules === void 0 ? void 0 : flagRules.find(function (rule) {
                return !rule.id.includes('default');
            });
            if (!validRule) {
                return Promise.resolve(result);
            }
            else {
                var abTestId = validRule.id;
                var abTestFlag = validRule.key;
                var flagId = configuration.experimentFeatureMap[abTestId];
                var testInformation = "".concat(input.featureName, "=").concat(flagId, ":").concat(abTestFlag, "=").concat(abTestId, ":").concat(input.bucket);
                result.bucket = testInformation;
            }
        }
        return Promise.resolve(result);
    },
    platforms: [
        {
            name: 'Heap',
            transform: function (input, enhancedData) {
                if (enhancedData === null || enhancedData === void 0 ? void 0 : enhancedData.bucket) {
                    return {
                        eventName: 'ab_test_bucket',
                        bucket: enhancedData.bucket
                    };
                }
                return {
                    eventName: 'ab_test_not_running',
                    testName: input.featureName
                };
            }
        }
    ]
});
